import { ChangeDetectionStrategy, Component } from '@angular/core';
import { ModalContainerService } from './modal-container.service';

@Component({
  selector: 'app-modal-container',
  templateUrl: './modal-container.component.html',
  styleUrls: ['./modal-container.component.scss'],
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ModalContainerComponent {
  readonly activeModal$ = this.modalContainer.activeModal$;

  constructor(private readonly modalContainer: ModalContainerService) {}

  close(): void {
    this.modalContainer.close();
  }
}
